module.exports = __webpack_public_path__ + "static/media/memories_4.09312ee7.jpg";